import {
  Box,
  Flex,
  Image,
  Link,
  Text,
  useColorModeValue
} from '@chakra-ui/react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import i18next from 'i18next';
import { useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavLink, useLocation, useParams } from 'react-router-dom';

import { COMMON_WEB_PATH } from '../../../constant';
import { routeMappingV4 } from './utils/routeMapping_v4';

const allowedTypes = ['SLOT', 'LIVE', 'FH', 'TABLE', 'BLOCKCHAIN'];

const GameTypeSelector = ({ gameMainTypeFromProps, ltr } = {}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const location = useLocation();

  const textColor = useColorModeValue('dark.100', 'light.100');

  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const { gameType, gameList } = isHandleAllGame || {};

  const splideRef = useRef();

  const { gameMainType } = useParams();

  //顯示的遊戲類型
  const combileType = useMemo(() => {
    if (gameType) {
      // 定義要保留的遊戲類型

      const filteredGameType = allowedTypes.filter((type) =>
        gameType.includes(type)
      );

      return ['LOBBY', ...filteredGameType];
    }
    return [];
  }, [gameType]);

  const gameSubTypeList = useMemo(() => {
    if (gameType) {
      return [
        ...combileType.map((item, index) => {
          const { link } = routeMappingV4(item);
          const current_game_type = routeMappingV4(item)?.origin;

          const itemChildren = (
            <Link
              as={(props) => <NavLink {...props} />}
              to={`${link}`}
              _hover={{
                textDecoration: 'none'
              }}
              display="flex"
              justifyContent={'center'}
              alignItems={'center'}
            >
              {(props) => {
                const { isActive } = props;
                return (
                  <Flex
                    role="group"
                    direction="column"
                    alignItems={'center'}
                    position="relative"
                    justifyContent="center"
                    transition="all 0.3s"
                  >
                    <Box
                      position="relative"
                      w="100%"
                      h="100%"
                      display="flex"
                      flexDirection={'column'}
                      alignItems={'center'}
                      justifyContent="center"
                    >
                      <Box w={'70px'} h="70px" position="relative">
                        <Image
                          src={`${COMMON_WEB_PATH}/blue-layout/footer/${current_game_type?.toUpperCase()}${
                            isActive ? '_active' : ''
                          }.png`}
                          width="100%"
                          height="100%"
                          transform="scale(1.3)"
                          _groupHover={{
                            src: `${COMMON_WEB_PATH}/blue-layout/footer/${current_game_type?.toUpperCase()}_active.png`
                          }}
                        />
                      </Box>
                      <Text
                        fontWeight={'300'}
                        fontSize="1em"
                        textShadow={'0 0 1px white'}
                        className="text-overflow"
                      >
                        {i18n(current_game_type)}
                      </Text>
                    </Box>
                  </Flex>
                );
              }}
            </Link>
          );
          return <>{itemChildren}</>;
        })
      ];
    }
  }, [gameType, gameList, combileType, textColor, ltr]);

  useEffect(() => {
    if (splideRef.current) {
      const mainType = gameMainTypeFromProps || gameMainType;
      const splide = splideRef.current.splide;
      const processGameType = gameType?.map((item) => {
        const textMapping = routeMappingV4(item);
        return textMapping?.link.replace('/', '');
      });
      splide.go(processGameType?.indexOf(mainType));
    }
  }, [gameType, gameMainType, gameMainTypeFromProps]);

  return (
    <Box
      position={'sticky'}
      top={location.pathname === '/' ? '90px' : '150px'}
      h={{
        base: 'calc(100vh - 220px)',
        md: '100%'
      }}
      overflowY={'scroll'}
      overflowX="hidden"
    >
      {gameSubTypeList}
    </Box>
  );
};

export default GameTypeSelector;
